import {useTranslation} from "react-i18next";

export const useFormatCurrency = (): (amount: number | string | undefined) => string => {
    const {i18n} = useTranslation()

    return (amount: number | string | undefined): string => {
        if (amount === undefined) {
            return ''
        }
        return new Intl.NumberFormat(i18n.language, {style: 'currency', currency: 'EUR'}).format(Number(amount))
    }
}
